<template>
    <div class="christmas-workout-card" :class="[{'christmas-workout-card--big': big}, {'christmas-workout-card--disabled': disabled}]"  @click.prevent="goTo">
        <div class="christmas-workout-card__inner">
            <v-lazy-image class="christmas-workout-card__image" :class="{'christmas-workout-card__image--top' : topImagePosition(workout.order)}" :src="workout.coverImageUrl ? workout.coverImageUrl : workout.imageUrl"></v-lazy-image>
            <div class="christmas-workout-card__content">
                <div class="christmas-workout-card__title">
                    <span>{{ workout.cid }}</span>
                    <Icon name="arrow-right" width="51px" height="51px" class="filled christmas-workout-card__title__icon"></Icon>
                </div>
                <Icon name="forbidden" width="60px" height="60px" class="filled christmas-workout-card__forbidden"></Icon>
                <div class="christmas-workout-card__category">{{ workout.category }}</div>
                <div class="christmas-workout-card__info" v-if="workout.difficulty && !isMobileNav">{{ create_time(workout) }} — {{ workout.difficulty.charAt(0).toUpperCase() + workout.difficulty.slice(1) }} — {{ workout.trainer.name }}</div>
                <div class="christmas-workout-card__info" v-if="workout.difficulty && isMobileNav">{{ workout.trainer.name }}</div>
            </div>
            <div class="christmas-workout-card__overlay"></div>
            <div class="christmas-workout-card__dimm"></div>
            <div class="christmas-workout-card__fulldimm"></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    props: {
        big: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        workout: {
            type: Object,
            default: () => {}
        }
       
    },
    data() {
        return {
            topPosition: [5,6,7,10,11,12,15,17,18,19,20,22,24]
        }
    },
    computed: {
        ...mapGetters(['isMobileNav']),
    },
    methods: {
        create_time(data) {
            var duration = data.duration;
            var mins = duration / 60;
            var hours = Math.floor(mins / 60);

            var retval = mins + ' min';
            if(hours >= 1){
                retval = hours + ' h ' + (mins - (hours * 60)) + ' min';
            }

            return retval;
        },
        goTo() {
            if(this.disabled) return;
            if(this.workout.url && !this.workout.url.includes(`share.pumatr.ac`) && !this.workout.url.includes(`global.puma.com`)) {
                window.open(this.workout.url, '_blank')
            } else {
                this.$router.push({ name: 'WorkoutOverview', params: { id: this.workout.id, christmasOverview: 'christmas', kind: this.workout.kind } })
            }
        },
        topImagePosition(order) {
            if(this.topPosition.includes(order)) return true;
            return false;
        }
    }
}
</script>

<style lang="scss">
.christmas-workout-card {
    $block: &;
    box-sizing: border-box;
    padding: 0;
    float: left;
    width: 100%;
    cursor: pointer;
    grid-row-end: span 1;

    &--big {
        grid-row-end: span 2 !important;
        #{$block} {
            &__inner {
                padding-bottom: 136.9%; 

            }
        }
    }

    &--disabled {
        cursor: not-allowed;
        #{$block} {
            &__title {
                color: $puma-color-black;
                bottom: 0;
                margin-bottom: 0;
            }

            &__overlay {
                background-color: rgba($puma-color-black, 0.85);
                -webkit-backdrop-filter: blur(2px);
                backdrop-filter: blur(2px);
            }

            &__category {
                color: $puma-color-black;
                background-color: rgba($puma-color-accent-60, 0.75);
            }

            &__forbidden {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: block;
                opacity: 0;
                transition: .25s all ease;
                color: rgba($puma-color-accent-60, 0.8);

                @include mq(tablet) {
                    opacity: 0;
                }
            }

            &__info {
                @include mq($until: tablet) {
                    display: none;
                }
            }
        }

         &:hover {
            .christmas-workout-card {
                &__overlay {
                    background: rgba(19,19,19, 0.85) !important;
                    -webkit-backdrop-filter: blur(2px);
                    backdrop-filter: blur(2px);
                }
                &__fulldimm {
                    -webkit-backdrop-filter: blur(2px);
                    backdrop-filter: blur(2px);
                    // background-image: linear-gradient(234deg, rgba(156, 133, 100, 0.5) 106%, rgba(156, 133, 100, 0.2) 48%, rgba(156, 133, 100, 0.8) -29%, #131313 -29%, #131313 -29%);
                    background-image: linear-gradient(234deg, rgba(156,133,100,0.8) -29%, rgba(19,19,19,1) -29%, rgba(19,19,19,1) -29%, rgba(156,133,100,0.2) 48%, rgba(156,133,100,0.5) 106%);
                }

                &__title {
                    top: unset !important;
                    transform: unset !important;
                    
                    &__icon {
                        display: none;
                    }

                    @include mq($until: tablet) {
                        opacity: 0;
                    }
                }
                
                &__info {
                    display: none !important;
                }

                &__category {
                     @include mq($until: tablet) {
                        opacity: 0;
                    }
                }

                &__forbidden {
                    opacity: 1 !important;
                }
                
            }
        }
    }

    &__inner {
        width: 100%;
        position: relative;
        padding-bottom: 66.66%;
        background-size: cover;
        background-position: center center;
        height: 0;
        border-radius: 4px;
        overflow: hidden;
    }

    &__image {
        @include object-fit;

        &--top {
            object-position: top;
        }
    }

    &__content {
        position: absolute;
        left: 18px;
        bottom: 20px;
        width: calc(100% - 38px);
        z-index: 10;
        height: calc(100% - 20px);

        @include mq($until: tablet) {
            left: 10px;
            bottom: 9px;
            width: calc(100% - 22px);
            height: calc(100% - 9px);
        }
    }

    &__running {
        margin-bottom: 15px;
    }

    &__title {
        color: $puma-color-white;
        display: block;
        text-transform: uppercase;
        font-size: $puma-size-font-5xl;
        line-height: 1;
        font-weight: bold;
        margin-bottom: 4px;
        position: absolute;
        bottom: 14px;
        margin-left: 0;
        transition: .25s all ease;

        @include mq(tablet) {
            font-size: $puma-size-font-7xl;
            bottom: 0;
            margin-left: 7px;
        }

        &__icon {
            opacity: 0;
            margin-left: 49px;

            @include mq($until:tablet) {
                display: none;
            }
        }
    }

    &__forbidden {
        display: none;
        transition: .25s all ease;
    }

    &__category {
        position: absolute;
        right: 0;
        top: 12px;
        background-color: rgba($puma-color-accent-60, 0.75);
        color: $puma-color-white;
        font-size: $puma-size-font-sm;
        line-height: 1.29;
        text-transform: uppercase;
        font-weight: 700;
        display: inline-block;
        padding: 1px 4px;

        @include mq(tablet) {
            bottom: unset;
            right: 0;
            top: 18px;
        }
    }

    &__info {
        color: $puma-color-white;
        font-size: $puma-size-font-xs;
        margin-top: 14px;
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;

        @include mq($until:tablet) {
            display: block;
        }

        @include mq(notebook) {
            font-size: $puma-size-font-sm;
        }
    }

    &__overlay {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        z-index: 5;
        transition: all .25s ease;
        background: rgba($puma-color-black, 0.2)
    }

    &__dimm {
        // background-image: linear-gradient(234deg, rgba(14, 14, 14, 0) 101%, rgba(156, 133, 100, 0.8) -32%, #131313 -32%, #131313 -32%);
        background: linear-gradient(to top right, rgba(19,19,19,1) -29%, rgba(19,19,19,1) -29%, rgba(156,133,100,0.8) -29%, rgba(14,14,14,0) 101%);
        position: absolute;
        left: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        z-index: 5;
        transition: all .25s ease;
    }
    &__fulldimm {
        background-image: linear-gradient(236deg, rgba(156, 133, 100, 0.5) 103%, rgba(156, 133, 100, 0.5) 50%, rgba(156, 133, 100, 0.8) -2%, #131313 -2%, #131313 -2%);              
        position: absolute;
        left: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        z-index: 6;
        opacity: 0;
        transition: all .25s ease;
    }

    .no-touch &:hover {
        .christmas-workout-card {
            &__overlay {
                background: transparent;
            }
            &__dimm {
                opacity: 0;
            }

            &__fulldimm {
                opacity: 1;
            }

            &__title {
                top: 50%;
                transform: translateY(-15%);

                @include mq($until: tablet) {
                    transform: none;
                }

                &__icon {
                    opacity: 1;
                }
            }

            &__info {
                display: block;
            }
        }
    }
}
</style>
